
import React from 'react';
import { Check } from 'lucide-react';

const Benefits = () => {
  const benefits = [
    '60 photos + 30 short videos every month',
    'Daily posts on Instagram, Facebook, TikTok, YouTube',
    'Strategic, branded content (not random)',
    'Fast replies to DMs & comments', 
    'Google Business optimization',
    'Monthly insights & growth tracking'
  ];

  return (
    <section id="pricing" className="section-container bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">What You Actually Get</h2>
          <div className="h-1 w-20 bg-grow99x-orange mx-auto"></div>
        </div>
        
        <div className="space-y-6">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-center space-x-4">
              <Check className="text-grow99x-orange" size={24} />
              <p className="text-lg">{benefit}</p>
            </div>
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <p className="text-xl font-bold mb-8">
            All this, for just $249/month. No fluff. No "agency talk." Just results.
          </p>
          
          <div className="border-2 border-grow99x-orange rounded-full py-4 px-6 flex items-center justify-center">
            <h3 className="text-2xl md:text-3xl font-bold text-grow99x-orange">
              WE TALK LESS AND DO MORE
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
